export default {
  tab: {
    order: 'Đặt lệnh',
    portfolio: 'Danh mục nắm giữ',
    assets: 'Tài sản',
  },
  tradingType: {
    BUY: 'Mua',
    SELL: 'Bán',
  },
  order: {
    Search: 'Mã chứng khoán',
    UserGuide: 'Hướng dẫn đặt lệnh',
    ChangeAccount: 'Chuyển tài khoản',
    Logout: 'Đăng xuất',
  },
  asserts: {
    MessageFiintrade: 'Fiintrade không quản lý tài sản của bạn',
    PleaseLogin: 'Vui lòng đăng nhập vào',
    MessagetoGetMoreInformation: 'để có thêm thông tin',
  },
};
